import * as React from 'react';
import { deleteSelectedAssets, getSelectedAssets } from '../viewstate';
import { observer } from 'mobx-react-lite';
import { getAssetCommands, isCommandButton, useProjectId } from 'owa-timestream-asset-sdk';
import loc from 'owa-localize';
import {
    TimeStreamToolboxButton,
    TimeStreamToolboxContextualMenu,
} from 'owa-timestream-toolbox-common';
import { FocusZone } from '@fluentui/react/lib/FocusZone';

export default observer(function TimeStreamAssetSubTools() {
    const projectId = useProjectId();
    const commands = getAssetCommands(projectId, getSelectedAssets(), deleteSelectedAssets);

    return (
        <FocusZone role="menu">
            {commands.map(command => {
                const { id, iconName, iconNameRTL, titleResourceId, disabled } = command;
                const commonProps = {
                    key: id,
                    iconName: iconName,
                    iconNameRTL: iconNameRTL,
                    title: loc(titleResourceId),
                    disabled: disabled,
                };

                return isCommandButton(command) ? (
                    <TimeStreamToolboxButton {...commonProps} onClick={command.onInvoke} />
                ) : (
                    <TimeStreamToolboxContextualMenu
                        {...commonProps}
                        menuItems={command.getMenuItems()}
                    />
                );
            })}
        </FocusZone>
    );
});
